var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1161 18.0176C14.3828 18.2343 13.5161 18.3343 12.4995 18.3343H7.49948C6.48281 18.3343 5.61615 18.2343 4.88281 18.0176C5.06615 15.8509 7.29115 14.1426 9.99948 14.1426C12.7078 14.1426 14.9328 15.8509 15.1161 18.0176Z",
    stroke: "#30BEAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4974 1.66602H7.4974C3.33073 1.66602 1.66406 3.33268 1.66406 7.49935V12.4993C1.66406 15.6493 2.61406 17.3743 4.88073 18.016C5.06406 15.8493 7.28906 14.141 9.9974 14.141C12.7057 14.141 14.9307 15.8493 15.1141 18.016C17.3807 17.3743 18.3307 15.6493 18.3307 12.4993V7.49935C18.3307 3.33268 16.6641 1.66602 12.4974 1.66602ZM9.9974 11.8077C8.3474 11.8077 7.01406 10.466 7.01406 8.81603C7.01406 7.16603 8.3474 5.83268 9.9974 5.83268C11.6474 5.83268 12.9807 7.16603 12.9807 8.81603C12.9807 10.466 11.6474 11.8077 9.9974 11.8077Z",
    stroke: "#30BEAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9823 8.81733C12.9823 10.4673 11.649 11.809 9.99896 11.809C8.34896 11.809 7.01562 10.4673 7.01562 8.81733C7.01562 7.16733 8.34896 5.83398 9.99896 5.83398C11.649 5.83398 12.9823 7.16733 12.9823 8.81733Z",
    stroke: "#30BEAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.aec1fdcd1e46179691a163568033e1f9.svg";
export { ForwardRef as ReactComponent };